// 
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}

// footer toggle
document.addEventListener("DOMContentLoaded", function () { 
    const toggles = document.querySelectorAll(".footer-toggle-btn");

    function isMobile() {
        return window.innerWidth <= 767;
    }

    toggles.forEach((btn) => {
        btn.addEventListener("click", function () {
            if (!isMobile()) return; // only run on mobile

            const parent = this.closest(".footer-toggle");
            const content = parent.nextElementSibling; // finds the .footer-toggle-content

            // toggle active state
            parent.classList.toggle("open");
            if (content && content.classList.contains("footer-toggle-content")) {
                content.classList.toggle("open");
            }
        });
    });
});


// kegs shop
$('.kegs-shop').owlCarousel({
    margin: 15,
    nav: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots: false,
    smartSpeed: 800,
    responsive: {
        0: {
            items: 2
        },
        600: {
            items: 3
        },
        768: {
            items: 4
        },
        1000: {
            items: 5
        },
        1280: {
            items: 6
        },
        1366: {
            items: 7
        },
        1536: {
            items: 8
        }
    }
})


// Featured tab
var owl = $('.featuredtab').owlCarousel({
    loop: false,
    nav: true,
    margin: 20,
    dots: false,
    smartSpeed: 800,
    responsive: {
        0: {
            items: 2,
            nav: false,
            dots: true
        },
        567: {
            items: 2,
            nav: false,
            dots: true
        },
        1000: { items: 3 },
        1200: { items: 4 }
    }
})

// product__media-list
//   var owl = $('.product__media-list').owlCarousel({
//     loop: false,
//     nav: true,
//     margin: 20,
//     dots: false,
//     smartSpeed: 800,
//     items: 1,
//     autoWidth: true
//   })
// $(document).ready(function () {
//   $(".owl-prev").html('<img src="https://cdn.shopify.com/s/files/1/0610/9206/9529/files/prev.png?v=1677746377" alt="arrow-left">');
//   $(".owl-next").html('<img src="https://cdn.shopify.com/s/files/1/0610/9206/9529/files/next.png?v=1677746377" alt="arrow-right">');
// });


// Infinite scroll
document.addEventListener("DOMContentLoaded", function() {
    var loader = document.getElementById('infinite-loader');
    var endlessScroll = new Ajaxinate({
        container: '#product-grid',
        pagination: '#Pagination',
        method: 'scroll', // auto infinite scroll
        loadingText: 'Loading..'
    });

    // Optional: show/hide loading spinner
    document.addEventListener('ajaxinate:loadStart', function() {
        loader.style.display = 'block';
    });
    document.addEventListener('ajaxinate:loadEnd', function() {
        loader.style.display = 'none';
    });
});

// remove filter
document.addEventListener('click', function(e) {
  const removeBtn = e.target.closest('.js-facet-remove, facet-remove a');
  if (!removeBtn) return;

  // Wait a bit for Shopify to update the DOM
  setTimeout(() => {
    const activeFilters = document.querySelectorAll('.active-facets__button, .active-facets__item');

    // If no active filters left → reload full page (not just Ajax)
    if (activeFilters.length === 0) {
      const cleanUrl = window.location.pathname; // base collection URL
      window.location.href = cleanUrl; // full reload
    }
  }, 300);
});